<template>
  <v-row>
    <v-col
      cols="12"
      lg="4"
      sm="6"
      v-for="card in cards"
      :card="card"
      :key="card.cardtitle"
      class="py-0 mb-7"
    >
      <v-card>
        <v-card-text class="pa-5">
          <div class="d-flex align-center">
            <v-btn
              :class="[card.iconcolor]"
              class="elevation-0"
              fab
              dark
            >
              <v-icon>{{ card.icon }}</v-icon>
            </v-btn>
            <div class="ml-2 mr-1">
              <h2 class="headline font-weight-light">
                {{ card.number }}
              </h2>
              <h5 class="subtitle-2 font-weight-regular">
                {{ card.title }}
              </h5>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "CardsInfor",
    props: ["numberOfReceived", "numberOfSent", "numberOfRead"],
    watch: {
      numberOfReceived(val) {
        this.cards[0].number = val
      },
      numberOfSent(val) {
        this.cards[1].number = val
      },
      numberOfRead(val) {
        this.cards[2].number = val
      }
    },
    data() {
      return {
        cards: [
          {
            title: "Total Recebidos",
            iconcolor: "info",
            icon: "mdi-call-received",
            number: this.numberOfReceived,
          },
          {
            title: "Total Enviados",
            iconcolor: "light-blue",
            icon: "mdi-send",
            number: this.numberOfSent
          },
          {
            title: "Total Lidos",
            iconcolor: "green",
            icon: "mdi-check-all",
            number: this.numberOfRead
          },
        ]
      }
    }
  }
</script>